export default "__VITE_ASSET__BehUV4Y$__"